import { render, staticRenderFns } from "./AttributesDisplay.vue?vue&type=template&id=42845cb6&scoped=true"
import script from "./AttributesDisplay.vue?vue&type=script&lang=js"
export * from "./AttributesDisplay.vue?vue&type=script&lang=js"
import style0 from "./AttributesDisplay.vue?vue&type=style&index=0&id=42845cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42845cb6",
  null
  
)

export default component.exports